
export const controlReasonHumanLabel = (reason: string | undefined): string => {
  switch (reason) {
    case "S0": return "plan scheduler service";
    case "S1+": return "reserved capacity stage; grid inflow reduction"; // TODO to be removed
    case "S1-": return "reserved capacity stage; grid outflow reduction"; // TODO to be removed
    case "PS": return "peak shaving stage; preparation for furnace run";
    case "PS+": return "peak shaving stage; power deficit";
    case "PS-": return "peak shaving stage; power excess";
    case "AG": return "automat stage; gas heating";
    case "AE": return "automat stage; electric heating";
    case "A+": return "automat stage; enabled automat";
    case "A-": return "automat stage; disabled automat";
    case "PVO": return "PV overflow";
    case "A": return "algorithm control";
    case "A-ARB": return "arbitrage algorithm control";
    default: return ""
  }
}
